// mapping form inputs to Google Spreadsheet Form id's
// NOTE: that for selects (platform), the answers must match one of the options,
// i.e. 'Yes' | 'No' to register in the form

const MASTER_LIST_MAILCHIMP_ID = 'a587f0abc1'

export const emailCollectionConfigs = {
  newsletter: {
    mailchimpListId: MASTER_LIST_MAILCHIMP_ID,
    googleSpreedsheet: {
      // Newsletter spreadsheet
      // https://docs.google.com/a/snips.ai/spreadsheets/d/1S6QIGvZMNy3njj9a7svOzmtLLX3bcPwSqDFPTHS46F4?usp=forms_web_b#gid=25317069
      url:
        'https://docs.google.com/a/snips.ai/forms/d/1ur6FAnuAhAxV-ClI9ygAY5gLbzxC58PiU0UQKoVX8k0/formResponse',
      ids: {
        email: 'entry.1575691157'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/config/email.js